import {AR_V2, CART_VIEW, CORE_AMZL, DEFAULT_CAPABILITIES} from "./Constants";
import {CART_VIEW_TABLE_COLUMNS_AMZL, CART_VIEW_TABLE_COLUMNS_AR} from "../routeStageStatus/CartViewTableColumns";
import {AR_SSD_ROUTE_VIEW_TABLE_COLUMNS, ROUTE_VIEW_TABLE_COLUMNS} from "../routeStageStatus/RouteViewTableColumns";
import {DEPART_TABLE_COLUMNS, DEPART_TABLE_COLUMNS_IN, DRIVER} from "../depart/DepartTableColumns";
import {convertEpochToHHMMSS, isARorSSD} from "./Util";

export function getStageDataInCSVFormat(cartList, routeList, viewType, capability, stationConfig) {
    if ((capability === AR_V2 || stationConfig.pickStageDecoupleEnabled) && viewType === CART_VIEW) {
        return getStageDataCartViewInCSVFormat(cartList, capability);
    } else {
        return getStageDataRouteViewInCSVFormat(routeList, capability);
    }
}

function getStageDataCartViewInCSVFormat(cartList, capability) {
    const csvData = [];
    //header
    if (capability === CORE_AMZL) {
        csvData.push(["Route Code", ...CART_VIEW_TABLE_COLUMNS_AMZL]);
    } else {
        csvData.push(["Route Code", ...CART_VIEW_TABLE_COLUMNS_AR]);
    }

    //rows
    cartList.forEach(cart => {
        const rowData = [];

        //ROUTE_CODE
        rowData.push(cart.routeCode);

        //DISPATCH_TIME
        if (capability === CORE_AMZL) {
            rowData.push(cart.routeSLA);
        }

        //CART_ID
        rowData.push(cart.cartId);

        //ROUTE_ID
        rowData.push(cart.routeId);

        //STAGE_BY_TIME
        if (capability === AR_V2) {
            rowData.push(cart.stageSLA);
        }

        //LOCATION
        rowData.push(cart.location);

        //STATUS
        rowData.push(cart.status);

        //DWELL_DURATION
        rowData.push(cart.dwellingDuration)

        //STAGE TIME
        if (capability === CORE_AMZL) {
            rowData.push(convertEpochToHHMMSS(cart.stageTime))
        }

        //ASSOCIATE
        rowData.push(cart.associate)

        //STATION_PAIRS
        if (capability === AR_V2) {
            rowData.push(cart.stationPairs);
        }

        //ROUTE_TYPE
        rowData.push(cart.routeType);

        csvData.push(rowData);
    });
    return csvData;
}

function getStageDataRouteViewInCSVFormat(routeList, capability) {
    const csvData = [];
    let columns = ["Route Code", ...ROUTE_VIEW_TABLE_COLUMNS];
    const isNodeARorSSD = isARorSSD(capability);
    if (isNodeARorSSD) {
        columns = ["Route Code", ...AR_SSD_ROUTE_VIEW_TABLE_COLUMNS];
    }
    if (capability === CORE_AMZL) {
        columns = columns.filter(column => column !== DRIVER);
    }

    //header
    csvData.push(columns);

    //rows
    routeList.forEach(route => {
        const rowData = [];

        //ROUTE_CODE
        rowData.push(route.routeCode);

        //DISPATCH_TIME
        rowData.push(route.routeSLA);

        //ROUTE_ID
        rowData.push(route.routeId);

        //LOCATION
        rowData.push(route.stagingLocation);

        //STATUS
        if (capability === AR_V2) {
            rowData.push(route.routeStatus);
        } else {
            rowData.push(route.stageStatus);
        }

        if (isNodeARorSSD) {
            rowData.push(route.stageProgress);
            rowData.push(route.picker);
        }
        //STAGE_TIME
        if (DEFAULT_CAPABILITIES.includes(capability)) {
            rowData.push(convertEpochToHHMMSS(route.stageTime))
        }
        if (isNodeARorSSD) {
            rowData.push(route.stageDuration);
        }

        //CARTS
        if (!isNodeARorSSD) {
            rowData.push(route.totalCarts)
        }

        //DRIVER
        if (capability === AR_V2) {
            rowData.push(route.driver);
        }

        //ROUTE_TYPE
        rowData.push(route.routeType);

        csvData.push(rowData);
    });
    return csvData;
}

export function getDepartDataInCSVFormat(routeList) {
    const csvData = [];
    const columns = ["Route Code", ...DEPART_TABLE_COLUMNS];

    //header
    csvData.push(columns);

    //rows
    routeList.forEach(route => {
        const rowData = [];

        //ROUTE_CODE
        rowData.push(route.routeCode);

        //DISPATCH_TIME
        rowData.push(route.routeSLA);

        //ROUTE_ID
        rowData.push(route.routeId);

        //LOCATION
        rowData.push(route.stagingLocation);

        //STATUS
        rowData.push(route.status);

        //PROGRESS
        rowData.push(route.departProgress)

        //DRIVER
        rowData.push(route.driver);

        //ROUTE_TYPE
        rowData.push(route.routeType);

        csvData.push(rowData);
    });
    return csvData;
}

export function getDepartDataInCSVFormatForIN(routeList) {
    const csvData = [];
    const columns = ["Route Code", ...DEPART_TABLE_COLUMNS_IN];

    //header
    csvData.push(columns);

    //rows
    routeList.forEach(route => {
        const rowData = [];

        //ROUTE_CODE
        rowData.push(route.routeCode);

        //DISPATCH_TIME
        rowData.push(route.routeSLA);

        //ROUTE_ID
        rowData.push(route.routeId);

        //LOCATION
        rowData.push(route.sectorCodes);

        //STATUS
        rowData.push(route.status);

        //PROGRESS
        rowData.push(route.stowProgress
            + (route.topOffPackageCount ? " + " + route.topOffPackageCount : ""));

        //DRIVER
        rowData.push(route.driver);

        //ROUTE_TYPE
        rowData.push(route.routeType);

        csvData.push(rowData);
    });
    return csvData;
}


// WEBPACK FOOTER //
// ./src/components/util/ExportUtils.js